import { ElementLike, GroupLike } from './groupSyncUtils';
import { createGroupResolver } from './previewGroupResolver';
import { resolvePreviewStep2GroupIds } from './previewStep2GroupResolver';

interface PreviewStep2Collections {
    texts?: ElementLike[];
    circularTexts?: ElementLike[];
    imagePlaceHolders?: ElementLike[];
    vectorsEps?: ElementLike[];
}

interface PreparePreviewStep2GroupDataInput {
    elementsGroups?: GroupLike[];
    groupsEps?: GroupLike[];
    listEPS?: Array<Record<string, any>>;
    loadFromStep1?: boolean;
    collections: PreviewStep2Collections;
}

interface PreparePreviewStep2GroupDataResult {
    groupsToLoad: GroupLike[];
    resolveLoadedElementGroupId: (element: ElementLike | null | undefined) => GroupLike['id'] | undefined;
    resolvedCollections: PreviewStep2Collections;
}

/**
 * Centralizes Step2 group preparation so loader code can stay focused on canvas creation.
 * This function guarantees that group collection generation and element groupId resolution
 * always use the same resolver pipeline.
 */
export function preparePreviewStep2GroupData(
    input: PreparePreviewStep2GroupDataInput
): PreparePreviewStep2GroupDataResult {
    const { elementsGroups = [], groupsEps = [], listEPS = [], loadFromStep1 = false, collections } = input;

    const { groupsToLoad, resolveGroupId } = createGroupResolver(elementsGroups, groupsEps, listEPS, loadFromStep1);
    const resolveLoadedElementGroupId = (element: ElementLike | null | undefined) =>
        resolveGroupId(element?.groupId, element?.uuid);

    const resolvedCollections = resolvePreviewStep2GroupIds(collections, resolveLoadedElementGroupId);

    return {
        groupsToLoad,
        resolveLoadedElementGroupId,
        resolvedCollections
    };
}

export function shouldCleanupEmptyGroupsOnStep2Load(loadFromStep1 = false, editMode = false): boolean {
    return Boolean(loadFromStep1 && !editMode);
}
